// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"R_thecomp__t7avR"};